export const envF = { ...process.env, ...window['env'] }